import * as Sentry from '@sentry/react';
import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { logoutUser } from 'features/session/sessionSlice';
import { logoutBackofficeUser } from 'features/backoffice/backofficeSlice';
import { cleanFavorites, cleanNextSteps } from 'features/user/userSlice';

export const unauthenticatedMiddleware: Middleware =
  ({ dispatch }) =>
  (next: (arg0: any) => any) =>
  (action: { payload: { status: number } }) => {
    if (isRejectedWithValue(action) && action.payload.status === 401) {
      if (
        window.location.pathname.includes('backoffice') &&
        !window.location.pathname.includes('login')
      ) {
        dispatch(logoutBackofficeUser());
        window.location.href = '/backoffice/login';
      } else {
        dispatch(logoutUser());
        dispatch(cleanFavorites());
        dispatch(cleanNextSteps());
      }
    }
    return next(action);
  };

export const serverErrorMiddleware: Middleware =
  () => (next: (arg0: any) => any) => (action: { payload: { status: number } }) => {
    if (isRejectedWithValue(action) && action.payload.status === 502) {
      Sentry.captureException(new Error('502 Bad Gateway'));
    }
    return next(action);
  };

export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    Sentry.captureException(new Error(action.payload.data.exception));
  }

  return next(action);
};
